import { api } from './client';
import type { ActorResponse, User } from './types';

export const authApi = {
  me: () => api.get<ActorResponse>('/auth/me'),
  signin: (email: string, password: string) =>
    api.post<{ user: User }>('/auth/signin', { email, password }),
  signup: (
    email: string,
    password: string,
    displayName: string,
    mergeGuestId: boolean,
  ) =>
    api.post<{ user: User }>('/auth/signup', {
      email,
      password,
      displayName,
      mergeGuestId,
    }),
  signout: () => api.post<void>('/auth/signout'),
};
